// Export an array of topics for VA 1st Grade Science
const md2ndScienceQuizContent = [
 
  {
    "slug": "magnetism",
    "title": "Magnetism",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What happens when two like magnetic poles get close?",
        "questionImage": "",
        "answers": [
          { "text": "They repel", "correct": true, "image": "" },
          { "text": "They attract", "correct": false, "image": "" },
          { "text": "They do nothing", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What happens when two opposite magnetic poles get close?",
        "questionImage": "",
        "answers": [
          { "text": "They attract", "correct": true, "image": "" },
          { "text": "They repel", "correct": false, "image": "" },
          { "text": "They melt", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Where are a magnet’s strongest points?",
        "questionImage": "",
        "answers": [
          { "text": "At the poles", "correct": true, "image": "" },
          { "text": "In the middle", "correct": false, "image": "" },
          { "text": "On the sides", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A magnetic field is best described as a kind of what?",
        "questionImage": "",
        "answers": [
          { "text": "Force", "correct": true, "image": "" },
          { "text": "Color", "correct": false, "image": "" },
          { "text": "Sound", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do we call a magnet made by electricity that is not permanent?",
        "questionImage": "",
        "answers": [
          { "text": "An electromagnet", "correct": true, "image": "" },
          { "text": "A permanent magnet", "correct": false, "image": "" },
          { "text": "A plastic magnet", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "force",
    "title": "Force",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each force word to what it does.",
        "options": [
          { "id": "push", "text": "Push", "image": "", "targetText": "Moves away from you", "targetImage": "" },
          { "id": "pull", "text": "Pull", "image": "", "targetText": "Moves toward you", "targetImage": "" },
          { "id": "twist", "text": "Twist", "image": "", "targetText": "Turns an object", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each motion change with the effect of a force.",
        "options": [
          { "id": "speedup", "text": "Speed up", "image": "", "targetText": "Goes faster", "targetImage": "" },
          { "id": "slowdown", "text": "Slow down", "image": "", "targetText": "Goes slower", "targetImage": "" },
          { "id": "turn", "text": "Change direction", "image": "", "targetText": "Turns left or right", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each action to the type of force.",
        "options": [
          { "id": "hammer", "text": "Hammer a nail", "image": "", "targetText": "Push", "targetImage": "" },
          { "id": "rope", "text": "Pull a rope", "image": "", "targetText": "Pull", "targetImage": "" },
          { "id": "knob", "text": "Turn a doorknob", "image": "", "targetText": "Twist", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match words to describe a force.",
        "options": [
          { "id": "push2", "text": "Push", "image": "", "targetText": "A force", "targetImage": "" },
          { "id": "pull2", "text": "Pull", "image": "", "targetText": "A force", "targetImage": "" },
          { "id": "kick", "text": "Kick", "image": "", "targetText": "A force", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match the picture idea to the motion it shows.",
        "options": [
          { "id": "start", "text": "Start moving", "image": "", "targetText": "Force makes it go", "targetImage": "" },
          { "id": "stop", "text": "Stop moving", "image": "", "targetText": "Force makes it stop", "targetImage": "" },
          { "id": "redirect", "text": "Turn a corner", "image": "", "targetText": "Force changes direction", "targetImage": "" }
        ]
      }
    ]
  },
  {
    "slug": "gravity",
    "title": "Gravity",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does each planet in our solar system orbit around?",
        "questionImage": "",
        "answers": [
          { "text": "The Sun", "correct": true, "image": "" },
          { "text": "The Moon", "correct": false, "image": "" },
          { "text": "The Earth", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which force keeps planets moving in their paths?",
        "questionImage": "",
        "answers": [
          { "text": "Gravity", "correct": true, "image": "" },
          { "text": "Wind", "correct": false, "image": "" },
          { "text": "Light", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If an object has more mass, what does gravity give it more of?",
        "questionImage": "",
        "answers": [
          { "text": "More pull", "correct": true, "image": "" },
          { "text": "Less pull", "correct": false, "image": "" },
          { "text": "No pull", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When you jump up, what happens next because of gravity?",
        "questionImage": "",
        "answers": [
          { "text": "You fall down", "correct": true, "image": "" },
          { "text": "You float up", "correct": false, "image": "" },
          { "text": "You stay up", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Gravity pulls people and objects toward which part of Earth?",
        "questionImage": "",
        "answers": [
          { "text": "Earth’s center", "correct": true, "image": "" },
          { "text": "The clouds", "correct": false, "image": "" },
          { "text": "The North Pole", "correct": false, "image": "" }
        ]
      }
    ]
  },
  {
    "slug": "matter",
    "title": "Matter",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each state to its trait.",
        "options": [
          { "id": "solid", "text": "Solid", "image": "", "targetText": "Keeps its shape", "targetImage": "" },
          { "id": "liquid", "text": "Liquid", "image": "", "targetText": "Takes container’s shape", "targetImage": "" },
          { "id": "gas", "text": "Gas", "image": "", "targetText": "Fills the space", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match particle motion to the state.",
        "options": [
          { "id": "tight", "text": "Packed tightly", "image": "", "targetText": "Solid", "targetImage": "" },
          { "id": "slide", "text": "Slide past each other", "image": "", "targetText": "Liquid", "targetImage": "" },
          { "id": "spread", "text": "Spread out and fast", "image": "", "targetText": "Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each example to its state.",
        "options": [
          { "id": "ice", "text": "Ice", "image": "", "targetText": "Solid", "targetImage": "" },
          { "id": "water", "text": "Water", "image": "", "targetText": "Liquid", "targetImage": "" },
          { "id": "steam", "text": "Steam", "image": "", "targetText": "Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each idea to matter.",
        "options": [
          { "id": "mass", "text": "Has mass", "image": "", "targetText": "Matter", "targetImage": "" },
          { "id": "space", "text": "Takes up space", "image": "", "targetText": "Matter", "targetImage": "" },
          { "id": "particles", "text": "Made of particles", "image": "", "targetText": "Matter", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each container idea.",
        "options": [
          { "id": "cup-water", "text": "Water in a cup", "image": "", "targetText": "Liquid takes shape", "targetImage": "" },
          { "id": "balloon-air", "text": "Air in a balloon", "image": "", "targetText": "Gas fills space", "targetImage": "" },
          { "id": "block", "text": "Wood block", "image": "", "targetText": "Solid keeps shape", "targetImage": "" }
        ]
      }
    ]
  },
  {
    "slug": "3statesofmatter",
    "title": "3 States of Matter",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match state to description.",
        "options": [
          { "id": "solidA", "text": "Solid", "image": "", "targetText": "Keeps shape", "targetImage": "" },
          { "id": "liquidA", "text": "Liquid", "image": "", "targetText": "Flows to fit", "targetImage": "" },
          { "id": "gasA", "text": "Gas", "image": "", "targetText": "Spreads to fill", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match example to state.",
        "options": [
          { "id": "rock", "text": "Rock", "image": "", "targetText": "Solid", "targetImage": "" },
          { "id": "juice", "text": "Juice", "image": "", "targetText": "Liquid", "targetImage": "" },
          { "id": "air", "text": "Air", "image": "", "targetText": "Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match particle picture words to state.",
        "options": [
          { "id": "packed", "text": "Packed tight", "image": "", "targetText": "Solid", "targetImage": "" },
          { "id": "slides", "text": "Slides past", "image": "", "targetText": "Liquid", "targetImage": "" },
          { "id": "farapart", "text": "Far apart", "image": "", "targetText": "Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match change words to heating/cooling.",
        "options": [
          { "id": "melt", "text": "Melting", "image": "", "targetText": "Solid → Liquid", "targetImage": "" },
          { "id": "freeze", "text": "Freezing", "image": "", "targetText": "Liquid → Solid", "targetImage": "" },
          { "id": "evap", "text": "Evaporation", "image": "", "targetText": "Liquid → Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each set that shows all three states.",
        "options": [
          { "id": "water-set", "text": "Ice / Water / Steam", "image": "", "targetText": "Solid / Liquid / Gas", "targetImage": "" },
          { "id": "soda-set", "text": "Ice / Soda / Bubbles", "image": "", "targetText": "Solid / Liquid / Gas", "targetImage": "" },
          { "id": "weather-set", "text": "Hail / Rain / Fog", "image": "", "targetText": "Solid / Liquid / Gas", "targetImage": "" }
        ]
      }
    ]
  },
{
  "slug": "animallifecycle",
  "title": "Animal Life Cycle",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each life cycle word to its meaning.",
      "options": [
        { "id": "born", "text": "Born", "image": "", "targetText": "Start of life", "targetImage": "" },
        { "id": "develop", "text": "Develop", "image": "", "targetText": "Grow and change", "targetImage": "" },
        { "id": "reproduce", "text": "Reproduce", "image": "", "targetText": "Make young", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each human stage to its description.",
      "options": [
        { "id": "baby", "text": "Baby", "image": "", "targetText": "Learns basics", "targetImage": "" },
        { "id": "child", "text": "Child", "image": "", "targetText": "Grows bigger", "targetImage": "" },
        { "id": "adult", "text": "Adult", "image": "", "targetText": "Can have young", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match frog stages to what they are.",
      "options": [
        { "id": "egg", "text": "Egg", "image": "", "targetText": "First stage", "targetImage": "" },
        { "id": "tadpole", "text": "Tadpole", "image": "", "targetText": "Tail and gills", "targetImage": "" },
        { "id": "adultfrog", "text": "Adult frog", "image": "", "targetText": "Legs and lungs", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match insect words to the stage.",
      "options": [
        { "id": "egg2", "text": "Egg", "image": "", "targetText": "First stage", "targetImage": "" },
        { "id": "larva", "text": "Larva", "image": "", "targetText": "Caterpillar/grub", "targetImage": "" },
        { "id": "pupa", "text": "Pupa", "image": "", "targetText": "Cocoon/chrysalis", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match the action to the life cycle idea.",
      "options": [
        { "id": "hatch", "text": "Hatch", "image": "", "targetText": "Egg to young", "targetImage": "" },
        { "id": "molt", "text": "Molt", "image": "", "targetText": "Larva grows", "targetImage": "" },
        { "id": "layeggs", "text": "Lay eggs", "image": "", "targetText": "Adult task", "targetImage": "" }
      ]
    }
  ]
},
{
  "slug": "plantlifecycle",
  "title": "Plant Life Cycle",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What protects the seed and the embryo inside?",
      "questionImage": "",
      "answers": [
        { "text": "Seed coat", "correct": true, "image": "" },
        { "text": "Leaf", "correct": false, "image": "" },
        { "text": "Bark", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. During germination, what comes out first and grows down?",
      "questionImage": "",
      "answers": [
        { "text": "The root", "correct": true, "image": "" },
        { "text": "The leaf", "correct": false, "image": "" },
        { "text": "The flower", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which set helps a plant grow?",
      "questionImage": "",
      "answers": [
        { "text": "Water, sun, soil, air", "correct": true, "image": "" },
        { "text": "Candy and paint", "correct": false, "image": "" },
        { "text": "Rocks and metal", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do we call a small plant with a few leaves?",
      "questionImage": "",
      "answers": [
        { "text": "Seedling", "correct": true, "image": "" },
        { "text": "Sprout", "correct": false, "image": "" },
        { "text": "Seed coat", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What helps plants make more plants?",
      "questionImage": "",
      "answers": [
        { "text": "Pollination", "correct": true, "image": "" },
        { "text": "Hibernation", "correct": false, "image": "" },
        { "text": "Migration", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "metamorphosis",
  "title": "Metamorphosis",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What is the process called when an animal changes its body form during its life?",
      "questionImage": "",
      "answers": [
        { "text": "Metamorphosis", "correct": true, "image": "" },
        { "text": "No change", "correct": false, "image": "" },
        { "text": "Disappearing", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. In a frog’s life cycle, what is the first stage?",
      "questionImage": "",
      "answers": [
        { "text": "Egg", "correct": true, "image": "" },
        { "text": "Pupa", "correct": false, "image": "" },
        { "text": "Adult", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do we call the young frog that lives in water and has a tail?",
      "questionImage": "",
      "answers": [
        { "text": "Tadpole", "correct": true, "image": "" },
        { "text": "Larva", "correct": false, "image": "" },
        { "text": "Nymph", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. As a tadpole grows into a frog, what new body parts appear?",
      "questionImage": "",
      "answers": [
        { "text": "Legs", "correct": true, "image": "" },
        { "text": "Wings", "correct": false, "image": "" },
        { "text": "Horns", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When a frog becomes an adult and lives on land, how does it breathe?",
      "questionImage": "",
      "answers": [
        { "text": "With lungs", "correct": true, "image": "" },
        { "text": "With gills", "correct": false, "image": "" },
        { "text": "With skin only", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "ladybug",
  "title": "Ladybug",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What is the first stage in a ladybug’s life cycle?",
      "questionImage": "",
      "answers": [
        { "text": "Egg", "correct": true, "image": "" },
        { "text": "Larva", "correct": false, "image": "" },
        { "text": "Adult", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is the second stage in a ladybug’s life cycle?",
      "questionImage": "",
      "answers": [
        { "text": "Larva", "correct": true, "image": "" },
        { "text": "Egg", "correct": false, "image": "" },
        { "text": "Pupa", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is the third stage in a ladybug’s life cycle?",
      "questionImage": "",
      "answers": [
        { "text": "Pupa", "correct": true, "image": "" },
        { "text": "Adult", "correct": false, "image": "" },
        { "text": "Egg", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What color is a typical adult ladybug’s shell?",
      "questionImage": "",
      "answers": [
        { "text": "Red", "correct": true, "image": "" },
        { "text": "Blue", "correct": false, "image": "" },
        { "text": "Green", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kind of marks are on a ladybug’s back?",
      "questionImage": "",
      "answers": [
        { "text": "Spots", "correct": true, "image": "" },
        { "text": "Stripes", "correct": false, "image": "" },
        { "text": "Stars", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "animalneeds",
  "title": "Animal Needs",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each basic need to its use.",
      "options": [
        { "id": "food", "text": "Food", "image": "", "targetText": "Eat", "targetImage": "" },
        { "id": "water", "text": "Water", "image": "", "targetText": "Drink", "targetImage": "" },
        { "id": "shelter", "text": "Shelter", "image": "", "targetText": "Home", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match habitat to its main oxygen source.",
      "options": [
        { "id": "land", "text": "Land habitat", "image": "", "targetText": "Air oxygen", "targetImage": "" },
        { "id": "waterHab", "text": "Water habitat", "image": "", "targetText": "Water oxygen", "targetImage": "" },
        { "id": "wetlands", "text": "Wetlands", "image": "", "targetText": "Both air and water", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each resource to what it gives.",
      "options": [
        { "id": "sunlight", "text": "Sunlight", "image": "", "targetText": "Energy", "targetImage": "" },
        { "id": "space", "text": "Space", "image": "", "targetText": "Room to live", "targetImage": "" },
        { "id": "soil", "text": "Soil", "image": "", "targetText": "Place to grow", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each action to the need it meets.",
      "options": [
        { "id": "hunt", "text": "Hunt", "image": "", "targetText": "Food", "targetImage": "" },
        { "id": "drink", "text": "Drink", "image": "", "targetText": "Water", "targetImage": "" },
        { "id": "nest", "text": "Build a nest", "image": "", "targetText": "Shelter", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each example to the resource.",
      "options": [
        { "id": "pond", "text": "Pond", "image": "", "targetText": "Water", "targetImage": "" },
        { "id": "grass", "text": "Grass", "image": "", "targetText": "Food", "targetImage": "" },
        { "id": "burrow", "text": "Burrow", "image": "", "targetText": "Shelter", "targetImage": "" }
      ]
    }
  ]
},
{
  "slug": "habitats",
  "title": "Habitats",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What is a habitat for a plant or an animal?",
      "questionImage": "",
      "answers": [
        { "text": "A home", "correct": true, "image": "" },
        { "text": "A toy", "correct": false, "image": "" },
        { "text": "A snack", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who lives together in a habitat at the same time?",
      "questionImage": "",
      "answers": [
        { "text": "Populations", "correct": true, "image": "" },
        { "text": "Robots", "correct": false, "image": "" },
        { "text": "Cars", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which needed resource does a habitat provide?",
      "questionImage": "",
      "answers": [
        { "text": "Food", "correct": true, "image": "" },
        { "text": "Games", "correct": false, "image": "" },
        { "text": "Music", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What other resource helps organisms survive in a habitat?",
      "questionImage": "",
      "answers": [
        { "text": "Water", "correct": true, "image": "" },
        { "text": "Confetti", "correct": false, "image": "" },
        { "text": "Glue", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which of these is a natural habitat?",
      "questionImage": "",
      "answers": [
        { "text": "Rainforest", "correct": true, "image": "" },
        { "text": "Backpack", "correct": false, "image": "" },
        { "text": "Shoe box", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "ecosystemsallaround",
  "title": "Ecosystems All Around",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which animal is common in grasslands?",
      "questionImage": "",
      "answers": [
        { "text": "Bison", "correct": true, "image": "" },
        { "text": "Penguins", "correct": false, "image": "" },
        { "text": "Sharks", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which plant is common in the ocean?",
      "questionImage": "",
      "answers": [
        { "text": "Seaweed", "correct": true, "image": "" },
        { "text": "Cactus", "correct": false, "image": "" },
        { "text": "Oak", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which animal is common in ponds and lakes?",
      "questionImage": "",
      "answers": [
        { "text": "Frogs", "correct": true, "image": "" },
        { "text": "Camels", "correct": false, "image": "" },
        { "text": "Tigers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which feature is typical of a forest?",
      "questionImage": "",
      "answers": [
        { "text": "Trees", "correct": true, "image": "" },
        { "text": "Coral", "correct": false, "image": "" },
        { "text": "Icebergs", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What does “biotic” mean in an ecosystem?",
      "questionImage": "",
      "answers": [
        { "text": "Living", "correct": true, "image": "" },
        { "text": "Nonliving", "correct": false, "image": "" },
        { "text": "Windy", "correct": false, "image": "" }
      ]
    }
  ]
},

{
  "slug": "determineweather",
  "title": "Determine Weather",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each measurement to what it tells you.",
      "options": [
        { "id": "temp", "text": "Temperature", "image": "", "targetText": "How hot or cold", "targetImage": "" },
        { "id": "precip", "text": "Precipitation", "image": "", "targetText": "Rain or snow", "targetImage": "" },
        { "id": "windspd", "text": "Wind speed", "image": "", "targetText": "How fast wind blows", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match wind words to what they mean.",
      "options": [
        { "id": "wdir", "text": "Wind direction", "image": "", "targetText": "N / S / E / W", "targetImage": "" },
        { "id": "wspd", "text": "Wind speed", "image": "", "targetText": "How fast", "targetImage": "" },
        { "id": "gust", "text": "Gust", "image": "", "targetText": "Sudden strong wind", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each tool to what it measures.",
      "options": [
        { "id": "thermo", "text": "Thermometer", "image": "", "targetText": "Temperature", "targetImage": "" },
        { "id": "baro", "text": "Barometer", "image": "", "targetText": "Air pressure", "targetImage": "" },
        { "id": "raing", "text": "Rain gauge", "image": "", "targetText": "Precipitation", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match humidity words to their ideas.",
      "options": [
        { "id": "humid", "text": "Humidity", "image": "", "targetText": "Water vapor in air", "targetImage": "" },
        { "id": "highhumid", "text": "High humidity", "image": "", "targetText": "Feels sticky", "targetImage": "" },
        { "id": "lowhumid", "text": "Low humidity", "image": "", "targetText": "Feels dry", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each time word to what is tracked over time.",
      "options": [
        { "id": "rainTotal", "text": "Total rainfall", "image": "", "targetText": "Amount over time", "targetImage": "" },
        { "id": "tempTrend", "text": "Temperature trend", "image": "", "targetText": "Change over time", "targetImage": "" },
        { "id": "windAvg", "text": "Average wind", "image": "", "targetText": "Average over time", "targetImage": "" }
      ]
    }
  ]
},

{
  "slug": "environmentalchange",
  "title": "Environmental Change",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When organisms adapt, what do they do to survive changes?",
      "questionImage": "",
      "answers": [
        { "text": "They change", "correct": true, "image": "" },
        { "text": "They quit", "correct": false, "image": "" },
        { "text": "They hide", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is it called when animals move to a new place to survive?",
      "questionImage": "",
      "answers": [
        { "text": "Migrate", "correct": true, "image": "" },
        { "text": "Hibernate", "correct": false, "image": "" },
        { "text": "Celebrate", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is it called when a kind of organism dies out and no longer exists?",
      "questionImage": "",
      "answers": [
        { "text": "Extinction", "correct": true, "image": "" },
        { "text": "Invention", "correct": false, "image": "" },
        { "text": "Prediction", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What can help some organisms survive better when the environment changes?",
      "questionImage": "",
      "answers": [
        { "text": "Useful traits", "correct": true, "image": "" },
        { "text": "Pretty colors only", "correct": false, "image": "" },
        { "text": "Songs", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which organisms are most likely to do well during changes?",
      "questionImage": "",
      "answers": [
        { "text": "Resilient ones", "correct": true, "image": "" },
        { "text": "Random ones", "correct": false, "image": "" },
        { "text": "Absent ones", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "surfacechange",
  "title": "Surface Change",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which process breaks rocks into smaller pieces over time?",
      "questionImage": "",
      "answers": [
        { "text": "Weathering", "correct": true, "image": "" },
        { "text": "Melting", "correct": false, "image": "" },
        { "text": "Boiling", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which process moves broken rock and soil from place to place?",
      "questionImage": "",
      "answers": [
        { "text": "Erosion", "correct": true, "image": "" },
        { "text": "Welding", "correct": false, "image": "" },
        { "text": "Painting", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which type of weathering happens when water dissolves minerals in rock?",
      "questionImage": "",
      "answers": [
        { "text": "Chemical weathering", "correct": true, "image": "" },
        { "text": "Mechanical weathering", "correct": false, "image": "" },
        { "text": "Musical weathering", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When ice or moving water breaks rock apart, what kind of weathering is this?",
      "questionImage": "",
      "answers": [
        { "text": "Mechanical weathering", "correct": true, "image": "" },
        { "text": "Chemical weathering", "correct": false, "image": "" },
        { "text": "Magnetic weathering", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What usually forms a canyon over a long time?",
      "questionImage": "",
      "answers": [
        { "text": "River erosion", "correct": true, "image": "" },
        { "text": "An earthquake", "correct": false, "image": "" },
        { "text": "Lightning", "correct": false, "image": "" }
      ]
    }
  ]
},
{
  "slug": "weathering",
  "title": "Weathering",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which process breaks rocks into smaller pieces?",
      "questionImage": "",
      "answers": [
        { "text": "Weathering", "correct": true, "image": "" },
        { "text": "Cooking", "correct": false, "image": "" },
        { "text": "Freezing", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which process moves rock and soil from one place to another?",
      "questionImage": "",
      "answers": [
        { "text": "Erosion", "correct": true, "image": "" },
        { "text": "Painting", "correct": false, "image": "" },
        { "text": "Reading", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is it called when moved rock and soil are dropped in a new place?",
      "questionImage": "",
      "answers": [
        { "text": "Deposition", "correct": true, "image": "" },
        { "text": "Evaporation", "correct": false, "image": "" },
        { "text": "Condensation", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What natural forces often cause weathering and erosion on Earth’s surface?",
      "questionImage": "",
      "answers": [
        { "text": "Wind and rain", "correct": true, "image": "" },
        { "text": "Music and art", "correct": false, "image": "" },
        { "text": "Games", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How do changes to Earth’s surface usually happen?",
      "questionImage": "",
      "answers": [
        { "text": "Over time", "correct": true, "image": "" },
        { "text": "Instantly", "correct": false, "image": "" },
        { "text": "Never", "correct": false, "image": "" }
      ]
    }
  ]
},

];

export default md2ndScienceQuizContent;
